export default [
    {
        path: '/showroom',
        name: 'showroom',
        /*
            This parent route doesn't have any functionality other than
            being a wrapper to child routes, so redirect to hub if it is hit directly
        */
        redirect: '/hub',
        component: () =>
            import(/* webpackChunkName: "showroom" */ '@/views/showroom'),
        children: [
            {
                path: 'find-customer',
                name: 'find-customer',
                component: () =>
                    import(
                        /* webpackChunkName: "find-customer" */ '@/views/showroom/find-customer'
                    ),
            },
            {
                // route name 'financing' already exists as a purchase step
                path: 'credit-preapply',
                name: 'credit-preapply',
                component: () =>
                    import(
                        /* webpackChunkName: "credit-preapply" */ '@/views/showroom/credit-preapply'
                    ),
            },
            {
                path: '/sell-my-car',
                name: 'sell-my-car',
                component: () =>
                    import(
                        /* webpackChunkName: "sell-my-car" */ '@/views/showroom/sell-my-car'
                    ),
            },
        ],
    },
];
